document.addEventListener("DOMContentLoaded", function () {
	trackChartStatesValues();
});

/**
 * Track select element for states.
 */
function trackChartStatesValues() {
	const chartBlocks = document.querySelectorAll(".chart-block");
	if (!chartBlocks.length) return;

	chartBlocks.forEach((block) => {
		const selectState = block.querySelector(".states-filter");
		if (selectState) {
			chartStateSelectDefault(selectState);
			selectState.addEventListener("change", function () {
				fetchStatesChart(block, this.value);
			});
		}
	});
}

// Update the default select option text based on the window width
function chartStateSelectDefault(selectState) {
	var defaultOption = selectState.querySelector(".default");
	if (window.innerWidth <= 767) {
		defaultOption.text = "Choose your state";
	} else {
		defaultOption.text = "Select";
	}
}

/**
 * Fetch new chart.
 */
function fetchStatesChart(block, state) {
	const baseUrl = sthm_ajax_params.site_url;
	var options = block.dataset.partArgs;
	var ids = block.querySelector(".default-ids").dataset.ids;
	let data = {
		state: state,
		options: options,
		ids: ids,
	};

	let params = new URLSearchParams(data).toString();
	let url = `${baseUrl}/sl-assets/themes/s-theme/includes/direct/charts.php?${params}`;
	// let url = `${baseUrl}/wp-content/themes/s-theme/includes/direct/charts.php?${params}`;

	fetch(url, {
		method: "GET",
	})
		.then((res) => {
			if (!res.ok) {
				throw new Error(`HTTP error!`);
			}
			return res.text();
		})
		.then((data) => {
			let parser = new DOMParser();
			let parsedDoc = parser.parseFromString(data, "text/html");
			let targetElement = block.querySelector(".list");
			targetElement.innerHTML = "";
			while (parsedDoc.body.firstChild) {
				targetElement.appendChild(parsedDoc.body.firstChild);
			}
		})
		.catch((err) => console.log("Error!", err));
}
